// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"10e7e832","726":"9a1b0e9e"}[chunkId] + ".chunk.js";
};